/**
 * DIEUKYDIEU.TV - AUDIO PLAYLIST COMBINED DATA
 */

import { tracksPart1 } from './tracks-part1.js';
import { tracksPart2 } from './tracks-part2.js';

export const audioPlaylist = [
    ...tracksPart1,
    ...tracksPart2
];

if (typeof window !== 'undefined') {
    window.AUDIO_PLAYLIST = audioPlaylist;
}
